/* HUSHLY — bloc d'achat : miniatures, choix du pack, ajout au panier sans quitter la page */
(function(){
  function init(root){
    (root || document).querySelectorAll('.hb').forEach(function(sec){
      if (sec.dataset.hbReady === '1') return;
      sec.dataset.hbReady = '1';

      /* miniatures */
      var thumbs = sec.querySelector('.hb-thumbs');
      if (thumbs){
        var main = document.getElementById(thumbs.dataset.main);
        thumbs.addEventListener('click', function(e){
          var b = e.target.closest('.hb-thumb'); if (!b || !main) return;
          main.src = b.dataset.src;
          thumbs.querySelectorAll('.hb-thumb').forEach(function(x){ x.classList.remove('is-on'); });
          b.classList.add('is-on');
        });
      }

      /* choix du pack : on recopie la variante choisie dans le champ du formulaire */
      var form = sec.querySelector('[data-hb-form]'); if (!form) return;
      var idField = form.querySelector('[data-hb-id]');
      var checked = form.querySelector('input[type=radio]:checked');
      if (checked) idField.value = checked.value;
      form.addEventListener('change', function(e){
        if (e.target.type === 'radio') idField.value = e.target.value;
      });

      /* ajout au panier sans recharger */
      var btn = form.querySelector('.hb-cta');
      var label = btn ? btn.textContent : '';
      form.addEventListener('submit', function(e){
        if (!window.fetch) return;              /* sans fetch, on laisse le POST classique */
        e.preventDefault();
        btn.disabled = true; btn.textContent = '…';
        fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items:[{ id: Number(idField.value), quantity: 1 }] })
        })
        .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
        .then(function(res){
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'refus');
          btn.textContent = sec.dataset.added || 'Added';
          document.dispatchEvent(new CustomEvent('hushly:cart:added'));
          /* on rafraichit le compteur du panier si le theme en expose un */
          return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
            document.querySelectorAll('.cart-count-bubble span:first-child').forEach(function(el){
              el.textContent = cart.item_count;
            });
            var bub = document.querySelector('.cart-count-bubble');
            if (!bub){
              var icon = document.querySelector('#cart-icon-bubble');
              if (icon && cart.item_count > 0){
                var s = document.createElement('div'); s.className = 'cart-count-bubble';
                s.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
                icon.appendChild(s);
              }
            }
          });
        })
        .catch(function(err){ btn.textContent = (sec.dataset.error || 'Try again'); console.warn('[hushly-buybox]', err); })
        .then(function(){ setTimeout(function(){ btn.disabled = false; btn.textContent = label; }, 1800); });
      });
    });
  }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', function(){ init(); }, {once:true});
  else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
